export default "__VITE_ASSET__922ee807__"